import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { handleMessage, requestMessage } from '@business/messages';
import { ClockinResponse, ClockinID } from '@business/entities/clockin';
import { ClockinAPI } from '@business/api/clockin';
import { BehaviorSubject } from 'rxjs';
import { tap, switchMap } from 'rxjs/operators';
import { ManualClockinFormData } from '@modules/dashboard/DashboardPage/ClockinToolbar/AddEditManualClockinModal/AddEditManualClockinModal';
import { showDeleteConfirmation } from '@modules/common';
import { FlashMessage } from '@core/components/FlashMessage';
import { tapError } from '@core/utils/rxjs/operators';

export class ClockinBloc extends BaseBloc {
  readonly activeTracker$ = new BehaviorSubject<ClockinResponse | null>(null);

  start = (data: any) => {
    return ClockinAPI.start(data).pipe(
      tap(tracker => this.activeTracker$.next(tracker)),
      handleMessage({
        error: requestMessage('create_clockin'),
      }),
    );
  };

  stop = (id: ClockinID) => {
    return ClockinAPI.stop(id).pipe(
      tap(() => this.activeTracker$.next(null)),
      handleMessage({
        type: requestMessage('stop_clockin'),
      }),
    );
  };

  getActive = () => {
    return ClockinAPI.getActive().pipe(
      tap(tracker => {
        if (tracker.id) {
          this.activeTracker$.next(tracker);
        } else {
          this.activeTracker$.next(null);
        }
      }),
    );
  };

  addManualTime = (data: ManualClockinFormData) => {
    return ClockinAPI.addManualTime(data).pipe(
      tap(res => FlashMessage.success('Manual Time', res.message)),
      tapError(() => {
        FlashMessage.error('Manual Time', 'Failed to add manual time');
      }),
    );
  };

  editClockin = (id: ClockinID, data: ManualClockinFormData) => {
    return ClockinAPI.editClockin(id, data).pipe(
      handleMessage({
        type: requestMessage('update_clockin'),
      }),
    );
  };

  deleteClockin = (id: ClockinID) => {
    return showDeleteConfirmation('Delete Clock In', `Do you really want to remove this clock in?`).pipe(
      switchMap(() => ClockinAPI.deleteClockin(id)),
      handleMessage({
        type: requestMessage('delete_clockin'),
      }),
    );
  };
}
